<template>
  <div class="rb-ob-form rb-match-page rb-tx-page">
    <header>
      <h1 class="rb-ob-title">{{ title }}</h1>
    </header>

    <div v-if="loading" class="rb-tx-panel" role="status">{{ $t('intake.portal.loading') }}</div>
    <div v-else class="rb-tx-panel">
      <p>{{ body }}</p>
    </div>

    <ul v-if="!loading" class="rb-tx-summary" :aria-label="$t('intake.treatment.doneMetaAria')">
      <li>
        <span class="rb-tx-k">{{ $t('intake.treatment.doneSession') }}</span>
        <span class="rb-tx-v">{{ sessionValue }}</span>
      </li>
      <li>
        <span class="rb-tx-k">{{ $t('intake.treatment.doneForm') }}</span>
        <span class="rb-tx-v">{{ formValue }}</span>
      </li>
      <li>
        <span class="rb-tx-k">{{ $t('intake.treatment.doneStatus') }}</span>
        <span class="rb-tx-v">{{ statusValue }}</span>
      </li>
    </ul>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="dashboard">
        {{ $t('intake.treatment.doneCta') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ loading ? $t('intake.portal.loading') : '' }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {fetchTreatmentAssessmentForm, hasAuthToken, toFaDigits} from '@/intake/portalApi'

export default {
  name: 'AssessDoneStep',
  data() {
    return {
      loading: true,
      form: null,
    }
  },
  computed: {
    kind() {
      return this.$route.query.kind === 'srs' ? 'srs' : 'ors'
    },
    instrument() {
      return this.kind === 'srs' ? 'SRS' : 'ORS'
    },
    requestedSessionId() {
      const raw = this.$route.query.sessionId
      return raw != null && String(raw).trim() !== '' ? String(raw) : ''
    },
    confirmed() {
      return !!(this.form && this.form.completed && String(this.form.sessionId) === this.requestedSessionId)
    },
    title() {
      if (this.loading) return this.$t('intake.portal.loading')
      return this.confirmed
        ? this.$t('intake.treatment.doneTitle')
        : this.$t('intake.treatment.doneStatusUnconfirmed')
    },
    body() {
      return this.confirmed
        ? this.$t('intake.treatment.doneBody')
        : this.$t('intake.treatment.doneStatusUnconfirmed')
    },
    sessionValue() {
      if (this.confirmed && Number(this.form.sessionNumber) > 0) {
        const number = String(this.form.sessionNumber)
        return this.$route.params.lang === 'en' ? number : toFaDigits(number)
      }
      return this.$t('intake.treatment.doneSessionUnknown')
    },
    formValue() {
      if (this.kind === 'srs') return this.$t('intake.treatment.doneFormSrs')
      return this.$t('intake.treatment.doneFormOrs')
    },
    statusValue() {
      return this.confirmed
        ? this.$t('intake.treatment.doneStatusValue')
        : this.$t('intake.treatment.doneStatusUnconfirmed')
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      if (!hasAuthToken() || !this.requestedSessionId) {
        this.loading = false
        return
      }
      fetchTreatmentAssessmentForm(this.requestedSessionId, this.instrument)
          .then((form) => {
            this.form = form
          })
          .catch(() => {
            this.form = null
          })
          .finally(() => {
            this.loading = false
          })
    },
    dashboard() {
      this.$router.push({
        name: 'portalHome',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
